import { FormattedStreamValue } from '@squaredup/data-streams';

export const RawCell: React.FC<FormattedStreamValue> = ({ raw }) => {
    if (raw === undefined) {
        return null;
    }

    return <>{raw}</>;
};
